import { Component } from '@angular/core';
import { AppState } from '../../../app.state';
import { UtilityService } from '../../services/utility/utility.service';

@Component({
    selector: 'upsc-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {
    public imageLink: string;

    public constructor(private readonly appState: AppState,
                       private readonly utilityService: UtilityService,
    ) {
        this.setLogo();
    }

    private setLogo(): void {
        const user = this.appState.user$();
        const isEU = this.utilityService.isEUCountry(user?.CountryCode) || this.utilityService.isEUDomainName();

        if (isEU) {
            this.imageLink = 'assets/images/logos/logo_upscapital_degb.png';
            return;
        }

        this.imageLink = 'assets/images/logos/ppi-logo.svg';
    }
}
